module.exports = __webpack_public_path__ + "img/房子.ce45c6fc.png";